import {otsBaseApi} from "../../ots-api";
import {PipelineGraphNode} from "../../../model/pipeline/pipeline-graph-node";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["PipelineGraphNodes"]});

const pipelineGraphNodeApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllPipelineGraphNodes: builder.query<PipelineGraphNode[], string | undefined>({
      query: (regionId) => ({
        url: `/pipeline-graph-node/all`,
        method: "GET",
      }),
      keepUnusedDataFor: 300,
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({id}) => ({type: "PipelineGraphNodes", id} as const)),
            {type: "PipelineGraphNodes", id: "LIST"}
          ];
        } else {
          return [{type: "PipelineGraphNodes", id: "LIST"}];
        }
      }
    }),
    getPipelineGraphNode: builder.query<PipelineGraphNode, string>({
      query: (id) => ({
        url: `/pipeline-graph-node/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{type: "PipelineGraphNodes", id}]
    }),
    createPipelineGraphNode: builder.mutation<PipelineGraphNode, Partial<PipelineGraphNode>>({
      query: (mapping) => ({
        url: "/pipeline-graph-node",
        method: "POST",
        body: mapping
      }),
      invalidatesTags: [{type: "PipelineGraphNodes", id: "LIST"}]
    }),
    updatePipelineGraphNode: builder.mutation<PipelineGraphNode, Partial<PipelineGraphNode>>({
      query: (mapping) => ({
        url: "/pipeline-graph-node",
        method: "PUT",
        body: mapping,
      }),
      invalidatesTags: (result, error, {id}) => [{type: "PipelineGraphNodes", id}]
    }),
    deletePipelineGraphNode: builder.mutation<void, Partial<PipelineGraphNode>>({
      query: (mapping) => ({
        url: "/pipeline-graph-node",
        method: "DELETE",
        body: mapping
      }),
      invalidatesTags: (result, error, {id}) => [{type: "PipelineGraphNodes", id}]
    })
  })
});

export const {
  useGetAllPipelineGraphNodesQuery,
  useGetPipelineGraphNodeQuery,
  useCreatePipelineGraphNodeMutation,
  useUpdatePipelineGraphNodeMutation,
  useDeletePipelineGraphNodeMutation,
} = pipelineGraphNodeApi;
